'use strict'

export default function ( $interval )
{

	function _apply ( element )
		{
			var initial = element.scrollWidth

			_init(element)

			$interval(function(){
				if (element.scrollWidth !== initial)
				{
					initial = element.scrollWidth
					_init(element)
				}
			}, 500)
		}

	function _init ( element )
		{
			var dir = 1,
				cur = element.scrollLeft,
				speed = parseInt(element.getAttribute('time-scroller')) || 1

			console.log(speed)

			$interval(function(){
				cur += speed * dir / 10
				element.scrollLeft = cur

				;(element.scrollLeft > element.scrollWidth - element.offsetWidth - 10) && (dir = -1)
				;(element.scrollLeft < 20) && (dir = 1)
			}, 10)
		}

	return {
		restrict: 'A',
		scope: {},
		link: function ( scope, elements, attrs )
			{
				angular.forEach(elements, _apply)
			}
	}
}


// WEBPACK FOOTER //
// ./src/app/directives/time-scroller/time-scroller.directive.js